<template>
  <div>
    <div
      v-if="loading"
      class="col-md-12 text-center"
      style="margin-top:25%"
    >
      <PulseLoader
        :loading="loading"
      ></PulseLoader>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12 ">
          <div class="">
            <div class="x_panel">
              <h2 class="float-left">Department List</h2>
              <ul class="nav navbar-right panel_toolbox align-right">
                <li v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_CREATE)">
                  <button type="button" class="btn btn-info btn-sm" @click="create">Add New <i class="fa fa-plus"></i></button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_PRINT)">
                  <button
                    @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                    <i class="fa fa-print" v-if="!isPrinting"></i>
                    <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                    {{ isPrinting ? 'Printing...' : 'Print' }}
                  </button>
                </li>
                <li  v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_PRINT)">
                  <vue-excel-xlsx
                    ref="excel"
                    :data="excelData"
                    :columns="excelHeader"
                    :file-name="'Department List'"
                    :file-type="'xlsx'"
                    :sheet-name="'sheetname'"
                    :disabled="isPrinting"
                    class="btn btn-primary btn-sm float-right"
                  >
                    <div
                      @click.prevent="handleExportPrint('excel')"
                    >
                      <i class="fa fa-file-excel-o"></i>
                      {{ isPrinting ? 'Preparing...' : 'Excel' }}
                    </div>
                  </vue-excel-xlsx>
                </li>
                <li>
                  <button @click="goBack" class="btn btn-danger btn-sm float-right ">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                </li>
              </ul>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-body">
                    <PerPageSelector v-model="offset" @change="onPerPageChange"/>

                    <div class="card-box table-responsive">
                      <p class="text-muted font-13 m-b-30"></p>
                      <table :class="getTableClasses" style="width:100%">
                        <thead>
                        <tr>
                          <th>#</th>
                          <th> Name</th>
                          <th> Code</th>
                          <th>Job Defer Approval (Only For Critical Equipment)</th>
                          <th> Status</th>
                          <th
                            v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_DELETE) || isPermissionExist(PERMISSIONS.DEPARTMENT_EDIT)"
                          >Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(department , index) in departments?.data" :key="department.id">
                          <td>{{index+1}}</td>
                          <td>{{department?.name}}</td>
                          <td>{{department?.code}}</td>
                          <td>{{department?.defer_approval}}</td>
                          <td>{{department?.status == 'Activate' ? 'Active' : 'Inactive'}}</td>
                          <td
                            v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_EDIT) || isPermissionExist(PERMISSIONS.DEPARTMENT_DELETE)"
                          >
                            <button v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_EDIT)" type="button" @click="edit(department)" class="btn btn-primary btn-sm">
                              <i class="fa fa-edit"></i>
                            </button>
                            <button
                              v-if="isPermissionExist(PERMISSIONS.DEPARTMENT_DELETE) && false"
                              type="button"
                              @click="destroy(department)"
                              class="btn btn-danger btn-sm"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <Pagination :pagination="departments" :getData="getData"  />

                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <h4 style="line-height: 10px;">Vessel Name: {{this.vesselName}}</h4>
                          <div style="line-height: 10px;" class="font-weight-bold">Department List</div>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                          <table :class="getTableClasses" style="width:100%">
                            <thead>
                            <tr>
                              <th>#</th>
                              <th> Name</th>
                              <th> Code</th>
                              <th>Job Defer Approval (Only For Critical Equipment)</th>
                              <th> Status</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(department , index) in printItems" :key="department.id">
                              <td>{{index+1}}</td>
                              <td>{{department?.name}}</td>
                              <td>{{department?.code}}</td>
                              <td>{{department?.defer_approval}}</td>
                              <td>{{department?.status == 'Activate' ? 'Active' : 'inactive'}}</td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="roleModal" tabindex="-1" role="dialog" aria-labelledby="customerModalLongTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5
                class="modal-title"
                id="customerModalLongTitle"
              >{{ editMode ? 'Edit' : 'Add New' }} Department</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form @submit.prevent="editMode ? update() : store()" @keydown="form.onKeydown($event)">
              <div class="modal-body">
                <alert-error :form="form"></alert-error>
                <div class="form-group">
                  <label>Department Name</label>
                  <input autocomplete="off" v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                  <has-error :form="form" field="name"></has-error>
                </div>
                <div class="form-group">
                  <label>Department Code</label>
                  <input autocomplete="off" v-model="form.code" type="text" name="code" class="form-control" :class="{ 'is-invalid': form.errors.has('code') }">
                  <has-error :form="form" field="code"></has-error>
                </div>
                <div class="form-group">
                  <label>Job Defer Approval (Only For Critical Equipment) </label>
                  <select v-model="form.defer_approval" name="status" class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
                <div class="form-group">
                  <label>Status </label>
                  <select v-model="form.status" name="status" class="form-control" :class="{ 'is-invalid': form.errors.has('status') }">
                    <option value="Activate">Activate</option>
                    <option value="Deactivate">Deactivate</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="form.busy" type="submit" class="btn btn-info">Save</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- Modal -->
    </div>
  </div>
</template>

<script>
    import auth from '../../auth'
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import ItemTable from "@/components/Item/ItemTable.vue";
    import {apiPrintData} from "@/utils/print";
    import PermissionsMixin from "@/mixin/permissionsMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";

    export default {
        mixins: [PermissionsMixin, goBackButtonMixin],
        components: {ItemTable, Pagination, PulseLoader},
        name: 'Department',
        data() {
            return {
                loading: false,
                editMode: false,
                query: '',
                queryFiled: 'name',
                appName: process.env.VUE_APP_NAME,
                vesselName: auth.getVesselName(),
                permissions: auth.getPermissionData(),
                isPrinting: false,
                printItems: [],
                departments: [],
                excelHeader: [],
                excelData: [],
                offset: 20,
                form: new Form({
                    id: '',
                    name: '',
                    code: '',
                    vessel_id: auth.getVesselId(),
                    status: 'Activate',
                    defer_approval: 'No',
                }),
                pagination: {
                    current_page: 1
                }
            }
        },

      computed: {
        getTableClasses() {
          return {
            'table': true,
            'text-center': true,
            'table-striped': !this.isPrinting,
            'table-bordered': !this.isPrinting,
            'table-sm': !this.isPrinting,
            'print-table': this.isPrinting,
          };
        }
      },
        mounted() {
            this.getData(1)
        },
        methods: {
            onPerPageChange() {
              this.getData(1);
            },

            getData(page = 1) {
                this.loading = true
                var params = {
                  page: page,
                  offset: this.offset,
                  is_all: 0,
                }
                this.$http.get('/api/filter/department/' + this.form.vessel_id, {params}).then(response => {
                    this.departments = response.data.success
                    this.loading = false
                }).catch(e => {
                    this.loading = false
                    let response = e.response;
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Name': `${item?.name || ''}`,
                'Code': `${item?.code || ''}`,
                'Job Defer Approval (Only For Critical Equipment)': `${item?.defer_approval || ''}`,
                'Status': `${item?.status == 'Activate' ? 'Active' : 'Inactive'}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                is_all: 1,
              };

              const res = await this.$http.get('/api/filter/department/' + this.form.vessel_id, {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Department List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            async handlePrint() {
              this.isPrinting = true;

              try {
                const params = {
                  is_all: 1,
                };

                const res = await this.$http.get('/api/filter/department/' + this.form.vessel_id, {params});
                this.printItems = res?.data?.success ?? [];

                this.$nextTick(() => {
                  apiPrintData('printArea', 'Department List');
                  this.isPrinting = false;
                });

              } catch (error) {
                console.error(error);
                this.isPrinting = false;
                printWindow.close();
              }
            },

            create() {
                this.editMode = false
                this.form.reset()
                this.form.clear()
                $('#roleModal').modal('show')
            },
            store() {
                this.form.busy = true
                this.form.post('/api/department').then(response => {
                    this.getData(Number(this.departments?.current_page))
                    $('#roleModal').modal('hide')
                    if (this.form.successful) {
                        this.$snotify.success('Department Successfully Saved')
                    } else {
                        this.$snotify.error(
                            'Something went wrong try again later.',
                            'Error'
                        )
                    }
                }).catch(e => {
                    let response = e.response
                    let status = e.response.status
                    if (status === 500) {
                        let msg = response.data.error
                        this.$snotify.error(msg)
                    }
                    if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                    // if (status === 422){
                    //   if (response.data?.errors) {
                    //     const errors = response.data.errors;
                    //     for (const key in errors) {
                    //       this.$snotify.error(errors[key][0])
                    //     }
                    //   }
                    // }
                })
            },

            edit(department) {
                this.editMode = true
                this.form.reset()
                this.form.clear()
                this.form.fill(department)
                $('#roleModal').modal('show')
            },
            update() {
                this.form.busy = true
                this.form._method = 'put';
                this.form.post('/api/department/' + this.form.id).then(response => {
                    this.getData(Number(this.departments?.current_page));
                    $('#roleModal').modal('hide');
                    if (this.form.successful) {
                        this.$snotify.success('Department Successfully Updated')
                    } else {
                        this.$snotify.error(
                            'Something went wrong try again later.',
                            'Error'
                        )
                    }
                }).catch(e => {
                    console.log(e)
                })
            },
            destroy(department) {
                this.$dialog.confirm('Do You Want to delete This ?').then(() => {
                    this.$http.delete('/api/department/' + department.id).then(response => {
                        this.getData(Number(this.departments?.current_page))
                        this.$snotify.success(
                            'Department  Successfully Deleted',
                            'Success'
                        )
                    }).catch(e => {
                        let response = e.response?.data
                        this.$snotify.error(
                            response?.error,
                            'error'
                        )
                    })
                }).catch(function () {

                })

            },
            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>

<style scoped>

</style>
